/*
 * ******************************************************************
 * Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { APP_ROUTES_UTIL } from "@app/app-routing.util";

export class VLR_CONSOLE {
    public static readonly EMPTY = "";
    public static readonly ROOT = "recovery";
    public static readonly LEGACY_ROOT = "protection";
    public static readonly ROOT_ABSOLUTE = APP_ROUTES_UTIL.absolutePath(this.EMPTY, this.ROOT);
    public static readonly DASHBOARD = "deployments";
    public static readonly DASHBOARD_ABSOLUTE = this.ROOT_ABSOLUTE + this.DASHBOARD;
    public static readonly REGIONS_SETUP = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "activate-region";
    public static readonly REGIONS_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.REGIONS_SETUP;
    public static readonly REGIONS_IMPORT = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "import-region";
    public static readonly REGIONS_IMPORT_ABSOLUTE = this.ROOT_ABSOLUTE + this.REGIONS_IMPORT;
    public static readonly SUBSCRIPTIONS = "subscriptions";
    public static readonly SUBSCRIPTIONS_SETUP = this.SUBSCRIPTIONS + APP_ROUTES_UTIL.SLASH + "create-subscription";
    public static readonly SUBSCRIPTIONS_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTIONS_SETUP;
    public static readonly SUBSCRIPTIONS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTIONS;
    public static readonly SUBSCRIPTION_REPORTS = "subscription-reports";
    public static readonly SUBSCRIPTION_REPORTS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SUBSCRIPTION_REPORTS;
    public static readonly ACTIVITY_LOG = "activitylog";
    public static readonly ACTIVITY_LOG_ABSOLUTE = this.ROOT_ABSOLUTE + this.ACTIVITY_LOG;
    public static readonly TASKS = "tasks";
    public static readonly TASKS_RELATIVE = this.ACTIVITY_LOG + APP_ROUTES_UTIL.SLASH + this.TASKS;
    public static readonly TASKS_ABSOLUTE = this.ROOT_ABSOLUTE + this.TASKS_RELATIVE;
    public static readonly EVENTS = "events";
    public static readonly EVENTS_RELATIVE = this.ACTIVITY_LOG + APP_ROUTES_UTIL.SLASH + this.EVENTS;
    public static readonly EVENTS_ABSOLUTE = this.ROOT_ABSOLUTE + this.EVENTS_RELATIVE;
    public static readonly SETTINGS = "settings";
    public static readonly SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.SETTINGS;
    public static readonly VLCR_SETTINGS = "vlcr";
    public static readonly VLCR_SETTINGS_RELATIVE = this.SETTINGS + APP_ROUTES_UTIL.SLASH + this.VLCR_SETTINGS;
    public static readonly VLCR_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.VLCR_SETTINGS_RELATIVE;
    public static readonly VCF_OAUTH_SETTINGS = "vcs";
    public static readonly VCF_OAUTH_SETTINGS_RELATIVE = this.VLCR_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.VCF_OAUTH_SETTINGS;
    public static readonly VCF_OAUTH_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.VCF_OAUTH_SETTINGS_RELATIVE;
    public static readonly VMC_OAUTH_SETTINGS = "vmc";
    public static readonly VMC_OAUTH_SETTINGS_RELATIVE = this.VLCR_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.VMC_OAUTH_SETTINGS;
    public static readonly VMC_OAUTH_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.VMC_OAUTH_SETTINGS_RELATIVE;
    public static readonly GCVE_SETTINGS = "gcve";
    public static readonly GCVE_SETTINGS_RELATIVE = this.VLCR_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.GCVE_SETTINGS;
    public static readonly GCVE_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.GCVE_SETTINGS_RELATIVE;
    public static readonly CARBON_BLACK_SETTINGS = "carbonblack";
    public static readonly CARBON_BLACK_SETTINGS_RELATIVE = this.VLCR_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.CARBON_BLACK_SETTINGS;
    public static readonly CARBON_BLACK_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.CARBON_BLACK_SETTINGS_RELATIVE;
    public static readonly CROWDSTRIKE_SETTINGS = "crowdstrike";
    public static readonly CROWDSTRIKE_SETTINGS_RELATIVE = this.VLCR_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.CROWDSTRIKE_SETTINGS;
    public static readonly CROWDSTRIKE_SETTINGS_ABSOLUTE = this.ROOT_ABSOLUTE + this.CROWDSTRIKE_SETTINGS_RELATIVE;
    public static readonly ADD_CS_INSTANCE = "add-instance";
    public static readonly ADD_CS_INSTANCE_RELATIVE = this.CROWDSTRIKE_SETTINGS_RELATIVE + APP_ROUTES_UTIL.SLASH + this.ADD_CS_INSTANCE;
    public static readonly ADD_CS_INSTANCE_ABSOLUTE = this.CROWDSTRIKE_SETTINGS_ABSOLUTE + APP_ROUTES_UTIL.SLASH + this.ADD_CS_INSTANCE;
    public static readonly ERROR_403 = "error";
    public static readonly CAPABILITIES_ERROR = "error-props";
    public static readonly CAPABILITIES_ERROR_ABSOLUTE = this.ROOT_ABSOLUTE + this.CAPABILITIES_ERROR;
    public static readonly ACCESS_REQUEST_SUCCESS = "success";
    public static readonly ACCESS_REQUEST_SUCCESS_ABSOLUTE = this.ROOT_ABSOLUTE + this.ACCESS_REQUEST_SUCCESS;
    public static readonly SITE_SETUP = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "setup-site";
    public static readonly SITE_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.SITE_SETUP;
    public static readonly START_BILLING = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "activate";
    public static readonly START_BILLING_ABSOLUTE = this.ROOT_ABSOLUTE + this.START_BILLING;
    public static readonly CLOUD_PAIRING = "register";
    public static readonly CLOUD_PAIRING_ABSOLUTE = this.ROOT_ABSOLUTE + this.CLOUD_PAIRING;
    public static readonly QUICK_PLANNER = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "solution-guide";
    public static readonly QUICK_PLANNER_ABSOLUTE = this.ROOT_ABSOLUTE + this.QUICK_PLANNER;
    public static readonly LICENSE_KEY_SETUP = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "create-license";
    public static readonly LICENSE_KEY_SETUP_ABSOLUTE = this.ROOT_ABSOLUTE + this.LICENSE_KEY_SETUP;
    public static readonly LICENSE_KEY_CHANGE = this.DASHBOARD + APP_ROUTES_UTIL.SLASH + "change-license";
    public static readonly LICENSE_KEY_CHANGE_ABSOLUTE = this.ROOT_ABSOLUTE + this.LICENSE_KEY_CHANGE;
}
